import React from 'react'
import Header from '../Header'
import Commercebanner from '../commerce/Commercebanner'
import Footer from '../Footer'
import Career from './Career'
import AcademicsPage from './AcademicsPage'
import Subjectcommerce from './Subjectcommerce'

const Academics = () => {
  return (
    <div>
      <Header/>
      <Commercebanner/>
      <AcademicsPage/>
      <Subjectcommerce/>
      <Career/>
      <Footer/>
    </div>
  )
}

export default Academics